import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PartnershipLogo from 'Common/PartnershipLogo';
import Button from 'Common/Button';
import Icon from 'Common/Icon';
import parsedPrice from 'Common/parsedPrice';

import styles from 'components/CarLeaseIndicator.scss';

/**
 * <PCPExplainer /> component.
 * @return {class} returns PCPExplainer instance
 */
class PCPExplainer extends Component {
  /**
   * @param {object} props - props passed
   */
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   *
   */
  static propTypes = {
    pcpData: PropTypes.object,
    indicatorType: PropTypes.string,
    buttonLink: PropTypes.string,
    price: PropTypes.string,
    isMobile: PropTypes.bool,
    buttonClose: PropTypes.func
  };

  /**
   * Renders <PCPExplainer /> component.
   *
   * @return {JSX} - renders a Price Indicator Data.
   */
  render() {
    const {
      pcpData,
      indicatorType,
      isMobile,
      buttonLink,
      buttonClose,
      price
    } = this.props;
    return (
      <div className={styles.container}>
        <h4>
          Representative {indicatorType} example{' '}
          <span className={styles.disclaimer}>(subject to status)</span>
        </h4>

        <div className={styles.tableContainer}>
          <table className={styles.priceTable}>
            <tbody>
              <tr>
                <td>On the road price</td>
                <td>{price}</td>
              </tr>
              <tr>
                <td>Cash deposit</td>
                <td>{parsedPrice(pcpData.consumerDeposit)}</td>
              </tr>
              <tr>
                <td>Term months</td>
                <td>{pcpData.termMonths} months</td>
              </tr>
              <tr>
                <td>Mileage PA</td>
                <td>{pcpData.annualMileage}</td>
              </tr>
              <tr>
                <td>Manufacturer deposit</td>
                <td>{parsedPrice(pcpData.lenderDeposit)}</td>
              </tr>
              <tr>
                <td>APR</td>
                <td>{pcpData.representativeAPR}%</td>
              </tr>
              <tr>
                <td>Optional final payment</td>
                <td>{parsedPrice(pcpData.optionalFinalPayment)}</td>
              </tr>
              <tr>
                <td>Monthly payment</td>
                <td>{parsedPrice(pcpData.monthlyPayment)}</td>
              </tr>
            </tbody>
          </table>

          <div className={styles.textContainer}>
            <p>
              <strong>Representative example</strong>: Monthly payments{' '}
              {parsedPrice(pcpData.monthlyPayment)}, Term {pcpData.termMonths}{' '}
              months, Contract length {pcpData.contractLengthMonths} months, Car
              price {price}, Cash deposit {parsedPrice(pcpData.consumerDeposit)}
              , Total amount of credit{' '}
              {parsedPrice(pcpData.totalAmountOfCredit)}, Total amount payable{' '}
              {parsedPrice(pcpData.totalAmountPayable)}, Representative APR{' '}
              {pcpData.representativeAPR}%, Total charges payable{' '}
              {parsedPrice(pcpData.totalChargesPayable)}, Fixed rate of interest
              pa {pcpData.fixedRateOfInterestPerAnnum}%, Manufacturer
              contribution {parsedPrice(pcpData.lenderDeposit)}, Optional final
              payment {parsedPrice(pcpData.optionalFinalPayment)}, Excess
              mileage fee {pcpData.excessCostPencePerMile}p/mile.
            </p>
            <p>
              Personal Contract Purchase (PCP) is a flexible way to finance your
              next car. Pay an initial deposit and monthly payments with
              interest. At the end of the agreement you can either:
            </p>
            <ul>
              <li>Return the car (subject to damage/mileage exceptions);</li>
              <li>
                Take out a new PCP agreement on the same or a different car;
              </li>
              <li>
                *Buy the car at the agreed optional final payment amount (What
                Car? estimation).
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.logoWrapper}>
          <PartnershipLogo extendStyle={isMobile ? styles.partnerLogo : ''} />
        </div>
        <div className={styles.interactive}>
          <Button
            size="small"
            type="primary"
            dataCy="pcpBestPrice"
            customDataBi={'autotrader-click'}
            href={buttonLink}
            attributeTarget={'_blank'}
            rel={'nofollow'}
          >
            Get the best price
            <Icon
              iconName={`newwindow`}
              size="xs"
              extendStyle={styles.externalIcon}
            />
          </Button>
          <p
            data-cy="pcpClose"
            data-bi="pcpClose"
            onClick={() => buttonClose()}
          >
            Close
          </p>
        </div>
      </div>
    );
  }
}

export default PCPExplainer;



// WEBPACK FOOTER //
// ./src/Common/PCPExplainer/index.js